// extracted by mini-css-extract-plugin
module.exports = {"container":"eventCard_container__3DDH3","card":"eventCard_card__oVRLL","image":"eventCard_image__2rNRi","detail":"eventCard_detail__NPRIa","desc":"eventCard_desc__3Qqr3"};